import type { JSX } from "react";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormControlNumberInput } from "@/components/formControls/formControlNumberInput";
import { plotDataCompletionStatus } from "@/helpers/realEstateDataValidationAndCompletenessHelpers";
import { useGetErrorMessage } from "@/hooks/useGetErrorMessage";
import { PropertyInformation } from "@/types/refineRealEstate/refineRealEstate";

import { StyledFormGridContainer, StyledFormSection, StyledFormSectionTitle } from "../refineRealEstate.styled";

interface PlotDataTabProps {
  readonly?: boolean;
}

export const PlotDataTab = ({ readonly }: PlotDataTabProps): JSX.Element => {
  const { t } = useTranslation("Common", { keyPrefix: "realEstate" });
  const getErrorMessage = useGetErrorMessage();

  const {
    control,
    formState: { errors },
    trigger,
    watch,
    setValue,
  } = useFormContext<PropertyInformation>();

  const plotArea = watch("plotData.plotArea");
  //const ownerShip = watch("generalInfo.ownership");

  useEffect(() => {
    const completionStatus = plotDataCompletionStatus(plotArea);

    setValue("plotData.completionStatus", completionStatus);
  }, [plotArea, setValue]);

  useEffect(() => {
    trigger();
  }, [trigger]);

  // const isCoOwnershipShareVisible = ownerShip
  //   ? ownerShip === OwnershipEnum.apartmentOwnership || ownerShip === OwnershipEnum.leaseholdApartmentOwnership
  //   : false;

  return (
    <StyledFormGridContainer>
      <StyledFormSection>
        <StyledFormSectionTitle>{`${t("totalPlotSize")} (m²)`}</StyledFormSectionTitle>
        <FormControlNumberInput
          name="plotData.plotArea"
          control={control}
          fullWidth
          error={!!errors.plotData?.plotArea}
          helperText={getErrorMessage(errors.plotData?.plotArea)}
          data-cy="refine-data-plot-area"
          disabled={!!readonly}
        />
      </StyledFormSection>
      <div />

      {/* {!isValuationPush && (
        <Box sx={{ gridColumn: "span 2" }}>
          <StyledFormSection>
            <StyledFormSectionTitle>{t("plotSizeInfo")}</StyledFormSectionTitle>
            <FormControlTextField name="plotData.plotSizeInfo" control={control} multiline rows={3} />
          </StyledFormSection>
        </Box>
      )} */}

      {/* {!isValuationPush && isCoOwnershipShareVisible && (
        <>
          <StyledFormSectionHeader>{t("coOwnershipShare.title")}</StyledFormSectionHeader>
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
            <StyledFormSection>
              <StyledFormSectionTitle>{t("coOwnershipShare.numerator")}</StyledFormSectionTitle>
              <FormControlNumberInput
                name="plotData.coOwnershipShare.numerator"
                control={control}
                fullWidth
                error={!!errors.plotData?.coOwnershipShare?.numerator}
                helperText={getErrorMessage(errors.plotData?.coOwnershipShare?.numerator)}
              />
            </StyledFormSection>
            <StyledFormSection>
              <StyledFormSectionTitle>{t("coOwnershipShare.denominator")}</StyledFormSectionTitle>
              <FormControlNumberInput
                name="plotData.coOwnershipShare.denominator"
                control={control}
                fullWidth
                error={!!errors.plotData?.coOwnershipShare?.denominator}
                helperText={getErrorMessage(errors.plotData?.coOwnershipShare?.denominator)}
              />
            </StyledFormSection>
          </Box>
        </>
      )} */}
    </StyledFormGridContainer>
  );
};
